import { render, staticRenderFns } from "./highWater.vue?vue&type=template&id=2cab37fd&scoped=true&"
import script from "./highWater.vue?vue&type=script&lang=js&"
export * from "./highWater.vue?vue&type=script&lang=js&"
import style0 from "./highWater.vue?vue&type=style&index=0&id=2cab37fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cab37fd",
  null
  
)

export default component.exports